export const extractFileInfo = (url: string) => {
  try {
    const fileName = url.split('/').pop() || ''

    if (!fileName) {
      return {
        url,
        fileName,
        extension: '',
      }
    }
    const lastDotIndex = fileName.lastIndexOf('.')

    const extension = fileName.slice(lastDotIndex + 1).toLowerCase()

    return {
      url,
      fileName,
      extension,
    }
  } catch {
    return { fileName: '', extension: '', url }
  }
}
